import { render, staticRenderFns } from "./DesignerPortfolio.vue?vue&type=template&id=8eb48ca6&"
import script from "./DesignerPortfolio.vue?vue&type=script&lang=js&"
export * from "./DesignerPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports